module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/talk.json
// module id = 285
// module chunks = 102867159831029